import { createFileRoute } from "@tanstack/react-router"
import { requirePermission } from "@/lib/require-permission"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/tool-categories",
)({
  staticData: {
    breadcrumb: [
      {
        label: "Workspace - Tool categories",
        href: "/settings/workspace/tool-categories",
      },
    ],
  },
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(queryClient, "tools:read", "/settings/workspace/general"),
})
